// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1FVty","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__lUt_p"};